import { createStructuredSelector } from 'reselect';
import {
    TASK_EQUIPMENT_LIST_DELIVERY_PLAN,
    TASK_EQUIPMENT_LIST_DELIVERY_PLAN_SUCCESS,
    TASK_EQUIPMENT_LIST_DELIVERY_PLAN_ERROR,
    EQUIPMENT_MODEL_UPDATE,
    EQUIPMENT_MODEL_UPDATE_SUCCESS,
    EQUIPMENT_MODEL_UPDATE_ERROR,
    EQUIPMENT_UNIT_UPDATE,
    EQUIPMENT_UNIT_UPDATE_SUCCESS,
    EQUIPMENT_UNIT_UPDATE_ERROR
} from '../actions';

export const TaskEquipmentListDeliveryPlan = (data) => ({
    type: TASK_EQUIPMENT_LIST_DELIVERY_PLAN,
    payload: data
});

export const TaskEquipmentListDeliveryPlanSuccess = (data) => ({
    type: TASK_EQUIPMENT_LIST_DELIVERY_PLAN_SUCCESS,
    payload: data
});

export const TaskEquipmentListDeliveryPlanError = (error) => ({
    type: TASK_EQUIPMENT_LIST_DELIVERY_PLAN_ERROR,
    payload: error
});

export const EquipmentModelUpdate = (data) => ({
    type: EQUIPMENT_MODEL_UPDATE,
    payload: data
});

export const EquipmentModelUpdateSuccess = (data) => ({
    type: EQUIPMENT_MODEL_UPDATE_SUCCESS,
    payload: data
});

export const EquipmentModelUpdateError = (error) => ({
    type: EQUIPMENT_MODEL_UPDATE_ERROR,
    payload: error
});

export const EquipmentUnitUpdate = (data) => ({
    type: EQUIPMENT_UNIT_UPDATE,
    payload: data
});

export const EquipmentUnitUpdateSuccess = (data) => ({
    type: EQUIPMENT_UNIT_UPDATE_SUCCESS,
    payload: data
});

export const EquipmentUnitUpdateError = (error) => ({
    type: EQUIPMENT_UNIT_UPDATE_ERROR,
    payload: error
});

const task_equipment = (state) => state.task_equipment;

export const TaskEquipmentSelector = createStructuredSelector({ task_equipment });
